// src/components/RPA/buttons/ClassifyComplianceButton.js
import React, { useState } from 'react';
import axios from 'axios';

const api = process.env.REACT_APP_API;

const ClassifyComplianceButton = ({ docId, onDone }) => {
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const [payload, setPayload] = useState(null);
  const [err, setErr] = useState('');

  const run = async () => {
    if (!docId) return;
    setBusy(true);
    setErr('');
    setPayload(null);

    try {
      // ✅ Correct route: matches backend (routes/index.js)
      const res = await axios.post(
        `${api}/admin/rpa/compliance/classify`,
        { docId },
        { withCredentials: true, validateStatus: () => true }
      );

      if (res.status === 200) {
        setPayload(res.data || {});
      } else {
        setErr(res.data?.message || `Unexpected status ${res.status}`);
      }

      setOpen(true);
      if (typeof onDone === 'function') onDone(); // refresh doc list if parent passed handler
    } catch (e) {
      console.error('[RPA] classify compliance failed:', e);
      setErr('Classification failed. Check backend logs.');
      setOpen(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <span style={{ display: 'inline-block' }}>
      <button onClick={run} disabled={busy}>
        {busy ? 'Classifying…' : 'Classify Compliance'}
      </button>

      {open && (
        <div style={panel}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
            <strong>Classification Result</strong>
            <button onClick={() => setOpen(false)} style={{ padding: '2px 8px' }}>
              Close
            </button>
          </div>

          {err && <p style={{ color: 'crimson' }}>{err}</p>}

          {!err && payload && (
            <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>
              {JSON.stringify(payload, null, 2)}
            </pre>
          )}
        </div>
      )}
    </span>
  );
};

const panel = {
  marginTop: 8,
  background: '#f8f9fb',
  border: '1px solid #e2e5ea',
  padding: 10,
  borderRadius: 8,
  maxWidth: 640
};

export default ClassifyComplianceButton;







// import React, { useState } from 'react';
// import axios from 'axios';

// const api = process.env.REACT_APP_API;

// const ClassifyComplianceButton = ({ docId, onDone }) => {
//   const [busy, setBusy] = useState(false);
//   const [open, setOpen] = useState(false);
//   const [payload, setPayload] = useState(null);
//   const [err, setErr] = useState('');

//   const run = async () => {
//     if (!docId) return;
//     setBusy(true);
//     setErr('');
//     setPayload(null);
//     try {
//       const res = await axios.post(
//         `${api}/admin/rpa/compliance/classify`,
//         { docId },
//         { withCredentials: true }
//       );
//       setPayload(res.data || {});
//       setOpen(true);
//       if (typeof onDone === 'function') onDone(); // refresh list
//     } catch (e) {
//       console.error('[RPA] classify compliance failed:', e);
//       setErr('Classification failed.');
//       setOpen(true);
//     } finally {
//       setBusy(false);
//     }
//   };

//   return (
//     <span style={{ display: 'inline-block' }}>
//       <button onClick={run} disabled={busy}>
//         {busy ? 'Classifying…' : 'Classify Compliance'}
//       </button>
//       {open && (
//         <div style={panel}>
//           <div style={{ display:'flex', justifyContent:'space-between', marginBottom:6 }}>
//             <strong>Classification Result</strong>
//             <button onClick={() => setOpen(false)} style={{ padding:'2px 8px' }}>Close</button>
//           </div>
//           {err && <p style={{ color:'crimson' }}>{err}</p>}
//           {!err && (
//             <pre style={{ whiteSpace:'pre-wrap', margin:0 }}>
// {JSON.stringify(payload, null, 2)}
//             </pre>
//           )}
//         </div>
//       )}
//     </span>
//   );
// };

// const panel = {
//   marginTop: 8,
//   background: '#f8f9fb',
//   border: '1px solid #e2e5ea',
//   padding: 10,
//   borderRadius: 8,
//   maxWidth: 640
// };

// export default ClassifyComplianceButton;
